<template>
  <div class="dispensing-evaluate" id="dispensingEvaluate">
    <div class="dispensing-evaluate_search" id="dispensingSearch">
      <el-form :model="searchForm" label-width="96px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="医生姓名">
              <el-select v-model="searchForm.doctorName" class="search-input" clearable filterable placeholder="">
                <el-option v-for="item in doctorOptions" :key="item.doctorId" :label="item.label"
                  :value="item.doctorName">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="送药是否及时">
              <el-select v-model="searchForm.deliveryTimeliness" class="search-input" clearable placeholder="">
                <el-option v-for="item in deliveryTimelyOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="包装是否完好">
              <el-select v-model="searchForm.packagingIntactness" class="search-input" clearable placeholder="">
                <el-option v-for="item in packageIntactOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="药效外观气味是否正常" label-width="160px">
              <el-select v-model="searchForm.liquidNormality" class="search-input" clearable placeholder="">
                <el-option v-for="item in medicineNormalOptions" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="评价时间">
              <el-date-picker v-model="searchForm.searchDate" class="search-input" range-separator="至" type="daterange"
                format="yyyy-MM-dd" value-format="yyyy-MM-dd" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label-width="0px">
              <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
              <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
              <el-button @click="handleExport">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div ref="dispensingTableWrap" class="dispensing-evaluate_table">
      <el-table v-loading="loading" :data="list" border :height="tableHeight" tooltip-effect="dark evaluate_table_tooltips">
        <el-table-column type="index" label="序号" width="50" fixed="left" />
        <el-table-column prop="doctorName" label="医生" width="100" fixed="left" />
        <el-table-column prop="patientName" label="患者姓名" width="100" />
        <el-table-column prop="phone" label="联系电话" width="130" />
        <el-table-column prop="deptName" label="就诊医馆" width="110" />
        <el-table-column prop="orderNumber" label="门诊单号" width="180" />
        <el-table-column prop="deliveryTimelyText" label="送药是否及时" width="130">
          <template slot-scope="scope">
            <span>{{ dictText(scope.row.deliveryTimeliness, deliveryTimelyOptions) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="packageIntactText" label="包装是否完好" width="130">
          <template slot-scope="scope">
            <span>{{ dictText(scope.row.packagingIntactness, packageIntactOptions) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="medicineNormalText" label="药效外观或气味是否正常" width="190">
          <template slot-scope="scope">
            <span>{{ dictText(scope.row.liquidNormality, medicineNormalOptions) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="suggestion" label="改进建议" min-width="220" show-overflow-tooltip />
        <el-table-column prop="evaluationTime" label="评价日期" width="160" />
      </el-table>
    </div>

    <div class="dispensing-evaluate_pagination" id="dispensingPagination">
      <el-pagination :current-page="pageIndex" :page-size="pageSize" layout="total, prev, pager, next, jumper"
        :total="total" @current-change="pageNoChange" />
    </div>
  </div>
</template>

<script>
import { debounce, dictText } from '@/utils/validateBase.js'
import { Utils } from '@/utils/utils'
import { prescriptionEvaluationList, prescriptionEvaluationExport } from '@/api/evaluate'
const deliveryTimelyOptions = [
  { label: '配送及时', value: 1 },
  { label: '配送较慢', value: 2 }
]

const packageIntactOptions = [
  { label: '包装完好', value: 1 },
  { label: '轻微破损/渗漏', value: 2 },
  { label: '破损/渗漏明显', value: 3 }
]

const medicineNormalOptions = [
  { label: '很正常', value: 1 },
  { label: '明显异常', value: 2 }
]

const optionText = (options, value) => {
  const option = options.find(item => item.value === value)
  return option ? option.label : ''
}

const getInitialSearchDate = vm => [
  Utils.timeFormat(Number(Utils.startOfDay(vm.$moment().startOf('month'))), 'yyyy-MM-DD'),
  Utils.timeFormat(Number(Utils.endOfDay(vm.$moment().endOf('month'))), 'yyyy-MM-DD')
]

export default {
  name: 'DispensingEvaluate',
  data() {
    return {
      doctorOptions: [],
      dictText: dictText,
      deliveryTimelyOptions,
      packageIntactOptions,
      medicineNormalOptions,
      loading: false,
      searchForm: {
        doctorName: '',
        patientName: '',
        deliveryTimeliness: '',
        packagingIntactness: '',
        liquidNormality: '',
        searchDate: getInitialSearchDate(this)
      },
      tableHeight: 400,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      importFile: null,
      list: []
    }
  },
  computed: {},
  created() {
    this.$getDoctorOptions({ appStatus: 0 })
    this.getList()
  },
  mounted() {
    this.$nextTick(() => {
      this.resizeTableHeight()
    })
    window.addEventListener('resize', this.resizeTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeTableHeight)
  },
  methods: {
    resizeTableHeight() {
      this.$nextTick(() => {
        const tableWrap = this.$refs.dispensingTableWrap
        if (tableWrap && tableWrap.clientHeight) {
          this.tableHeight = tableWrap.clientHeight
          return
        }
        const evaluate = document.getElementById('dispensingEvaluate')
        const search = document.getElementById('dispensingSearch')
        const pagination = document.getElementById('dispensingPagination')
        const evaluateHeight = evaluate ? evaluate.clientHeight : 0
        const searchHeight = search ? search.clientHeight : 0
        const paginationHeight = pagination ? pagination.clientHeight : 0
        this.tableHeight = Math.max(evaluateHeight - searchHeight - paginationHeight - 40, 240)
      })
    },
    getList() {
      prescriptionEvaluationList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        condition: { ...this.searchForm, startTime: this.searchForm.searchDate[0], endTime: this.searchForm.searchDate[1] }
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data.records
          this.total = res.data.total
          this.resizeTableHeight()
        }
      })
    },
    search() {
      this.pageIndex = 1
      this.getList()
    },
    reset() {
      this.searchForm = {
        doctorName: '',
        patientName: '',
        deliveryTimeliness: '',
        packagingIntactness: '',
        liquidNormality: '',
        searchDate: getInitialSearchDate(this)
      }
      this.pageIndex = 1
      this.getList()
    },
    pageNoChange(num) {
      this.pageIndex = num
      this.getList()
    },
    handleExport: debounce(function () {
      prescriptionEvaluationExport({
        ...this.searchForm,
        startTime: this.searchForm.searchDate[0],
        endTime: this.searchForm.searchDate[1]
      },{name: '配药服务评价'}).then(res => {
        if (res.code === 200) {
          this.$message.success('导出成功')
        }
      })
    }, 1000, true)
  }
}
</script>

<style lang="less" scoped>
.dispensing-evaluate {
  box-sizing: border-box;
  padding: 20px;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dispensing-evaluate_search {
  overflow: hidden;
}

.dispensing-evaluate_table {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
}

.dispensing-evaluate_table /deep/ .el-table {
  flex: 1;
}

.dispensing-evaluate_pagination {
  flex: none;
  margin: 20px 0 0;
}

.import-content {
  padding: 4px 0 10px;
}

.import-title {
  margin-bottom: 14px;
  color: #1f2329;
  font-size: 14px;
  font-weight: 600;
}

.upload-box {
  display: flex;
  align-items: center;
}

.upload-tip {
  margin-left: 10px;
  color: #606266;
  font-size: 13px;
}
</style>

<style lang="less">
.evaluate_table_tooltips {
  max-width: 400px;
}
</style>